import { Route} from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { UnknownComponent } from './unknown/unknown.component';
import { AppRouting } from './shared/constants';

export const appRoutes: Route[] =  [
  {
    path: 'not-found',
    canActivate: [MsalGuard],
    component: UnknownComponent
  },
  {
    path: AppRouting.USER_MANAGEMENT,
    canActivateChild: [MsalGuard],
    loadChildren: () => import('./user-management/user-management.routing').then(m => m.userManagementRoutes)
  },
  {
    path: AppRouting.ACCESS_CONTROL,
    canActivateChild: [MsalGuard],
    loadChildren: () => import('./access-control/access-control.routing').then(m => m.accessControlRoutes),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: AppRouting.USER_MANAGEMENT
  },
  {
    path: '**',
    redirectTo: 'not-found'
  },
];
